// HeroSection.tsx
import { FC } from "react";
import privacyIllustration from "../../../images/privacy-illus.png";
import { useTranslation } from "react-i18next";

const PrivacySection: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="flex flex-col gap-y-4 lg:flex-row lg:items-center gap-x-[81px] px-8 md:px-9 pt-10 pb-12 md:py-[96px] bg-[#D9D9D9] text-center">
      <img src={privacyIllustration} alt="" className="w-[579px] xl:w-[755px]" />
      <div className="flex flex-col items-start text-left">
        <h3 className="text-[52px] text-[#3F3E3E] font-[200] leading-[62.93px]">
          {t("identityProtectedQuest")}
        </h3>
        <p className="mt-[10px] text-[18px] leading-[21.78px] font-[200]">
          {t("identityProtectedAnswer")}
        </p>
      </div>
    </section>
  );
};

export default PrivacySection;
